// Client-side Sentry configuration (browser)
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = "/monitoring-tunnel";globalThis["SENTRY_RELEASE"] = {"id":"53d82679"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/applicant-portal";import * as Sentry from '@sentry/nextjs';

// Define allowed environments
type Environment = 'local' | 'develop' | 'staging' | 'preprod' | 'production';

// Get current environment
const getCurrentEnvironment = (): Environment => {
  const env = process.env.NEXT_PUBLIC_ENV_NAME;
  switch (env) {
    case 'staging':
      return 'staging';
    case 'preprod':
      return 'preprod';
    case 'production':
      return 'production';
    case 'develop':
      return 'develop';
    default:
      return 'local';
  }
};

// Get environment specific configuration
const getEnvConfig = (environment: Environment) => {
  const configs = {
    develop: {
      tracesSampleRate: 1.0,
      debug: true
    },
    staging: {
      tracesSampleRate: 0.5,
      debug: true
    },
    preprod: {
      tracesSampleRate: 0.2,
      debug: false
    },
    production: {
      tracesSampleRate: 1.0, // between 0 - 1
      debug: false
    },
    local: {
      tracesSampleRate: 1.0,
      debug: false
    }
  };

  return configs[environment];
};

const environment = getCurrentEnvironment();
const envConfig = getEnvConfig(environment);

// Chrome on iOS uses WebKit's non-JIT interpreter, which has a smaller call stack
// than Safari's JIT-compiled path. Sentry's navigation instrumentation adds wrapper
// functions that push the stack over WebKit's limit during App Router navigations,
// causing RangeError: Maximum call stack size exceeded. Disabling navigation tracing
// on iOS prevents this while keeping all other performance and error tracking intact.
const isIOS =
  typeof navigator !== 'undefined' &&
  (/iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1));

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment,
  integrations: [
    Sentry.browserTracingIntegration({
      instrumentNavigation: !isIOS
    })
    //TODO @ashutosh need to enable it
    // Critical integration for filtering third-party errors - !!!! DO NOT MODIFY !!!!
    // Sentry.thirdPartyErrorFilterIntegration({
    // filterKeys: ['V1-APPLICANT-PORTAL'],
    // behaviour: 'drop-error-if-contains-third-party-frames'
    // }),
  ],

  beforeSend(event) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('TEST_SENTRY', event);
    }

    // Add environment data to the event
    event.environment = environment;
    event.tags = {
      ...event.tags,
      environment
    };

    return event;
  },

  // Use environment specific configuration
  tracesSampleRate: envConfig.tracesSampleRate,
  debug: envConfig.debug,

  enabled: !!(
    process.env.NODE_ENV !== 'development' &&
    process.env.NEXT_PUBLIC_SENTRY_ENABLED
  )
  // Enable this for local testing
  // enabled: true
});
